"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformRelatedProducts = exports.transformProduct = void 0;

var _array = require("lodash/array");

var _object = require("lodash/object");

var _collection = require("lodash/collection");

var transformProductMedia = function transformProductMedia(media, size) {
  var image = (0, _array.head)(media);
  return "".concat(image.path, "/").concat(image.file, "_").concat(size, ".").concat(image.ext);
};

var transformProductImages = function transformProductImages(medias, size) {
  return (0, _collection.map)(medias, function (image) {
    return "".concat(image.path, "/").concat(image.file, "_").concat(size, ".").concat(image.ext);
  });
};

var transformProductContent = function transformProductContent(content) {
  return {
    title: (0, _object.get)(content, 'title', null),
    text: (0, _object.get)(content, 'text', null)
  };
};

var transformProduct = function transformProduct(_ref) {
  var attributes = _ref.attributes,
      id = _ref.id;
  return {
    active: attributes.active,
    badges: attributes.badges.map(function (badge) {
      return {
        params: {
          '{unit}': badge.params['{unit}'],
          '{value}': badge.params['{value}']
        },
        title: badge.title,
        textModifier: badge.text_modifier,
        type: badge.type
      };
    }),
    brand: {
      brandID: attributes.brand.brand_id,
      name: attributes.brand.name,
      slug: attributes.brand.slug
    },
    contents: {
      ingredients: transformProductContent((0, _collection.find)(attributes.contents, ['title', 'Ingredientes']) || (0, _collection.find)(attributes.contents, ['title', 'Ingredients'])),
      alcohol: transformProductContent((0, _collection.find)(attributes.contents, ['title', 'Alcohol']))
    },
    description: attributes.description,
    id: id,
    isPromo: attributes.is_promo,
    manufacturer: attributes.manufacturer,
    measurementUnit: attributes.measurement_unit,
    medias: {
      small: transformProductMedia(attributes.medias.image, 'small'),
      large: transformProductMedia(attributes.medias.image, 'large'),
      xl: transformProductMedia(attributes.medias.image, 'xl')
    },
    name: attributes.name,
    oldPrice: Number.parseFloat(attributes.old_price).toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }),
    price: Number.parseFloat(attributes.price).toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }),
    priceMeasurementUnit: attributes.price_measurement_unit,
    priceUnit: parseFloat(attributes.price_unit),
    images: transformProductImages(attributes.medias.image, 'xl'),
    promo: attributes.promo,
    slug: attributes.slug,
    tags: attributes.tags.map(function (tag) {
      return {
        name: tag.name,
        slug: tag.slug,
        generic: tag.generic,
        pos: tag.pos,
        group: tag.group
      };
    }),
    unitQuantity: attributes.unit_quantity
  };
};

exports.transformProduct = transformProduct;

var transformRelatedProducts = function transformRelatedProducts(products) {
  return products.map(function (product) {
    return transformProduct(product);
  });
};

exports.transformRelatedProducts = transformRelatedProducts;